<template>
    <div class="receipt-list-view">
        <!-- 搜索项 -->
        <Row type="flex">
            <div class="flex-child">
                <span class="input-label">选择部门</span>
                <span class="Cascader">
                    <Cascader :data="departmentData"
                        v-model="department"
                        @on-change="getCascader"
                        change-on-select></Cascader>
                </span>
            </div>
            <div class="flex-child">
                结算渠道：
                <Select v-model="settleChannel" style="width:100px;" @on-change="getSettleChannel">
                    <Option v-for="item in settleChannelList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div class="flex-child">
                <span class="input-label">开始日期</span>
                <DatePicker
                    type="date"
                    placeholder="选择日期"
                    :options="options1"
                    v-model="startDate"
                    @on-change="getFormatStartDate">
                </DatePicker>
            </div>
            <div class="flex-child">
                <span class="input-label">结束日期</span>
                <DatePicker
                    type="date"
                    placeholder="选择日期"
                    :options="options2"
                    v-model="endDate"
                    @on-change="getFormatEndDate"></DatePicker>
            </div>
            <div class="flex-child">
                状态查询：
                <Select v-model="completeIndex" style="width:100px;" @on-change="getCompleteState">
                    <Option v-for="item in completeLsit" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
                <Checkbox v-model="single" @on-change="singleChange">包含作废</Checkbox>
            </div>
            <div class="flex-child">
                <Button type="primary" :loading="checkLoading">
                    <span v-if="!checkLoading" @click="checkList">查询</span>
                    <span v-else>查询...</span>
                </Button>
            </div>
        </Row>

        <!-- 新建项 -->
        <div class="receipts-operation" style="text-align: right">
            <div class="flex-child-input">
                <Input v-model="filterWord"
                    placeholder="请输入单据号搜索">
                    <Button slot="append" @click="search">搜索</Button>
                </Input>
            </div>
        </div>

        <!-- 表格 -->
        <Table :columns="columns12" :data="receiptData" :loading="loading" :height="530">
            <template slot-scope="{ row }" slot="action">
                <div v-if="row.destroyStatus !== 1">
                    <Button type="error" size="small" @click="removeNo(row.originNo)">删除</Button>
                </div>
                <div v-else>--</div>
            </template>
            <template slot-scope="{ row }" slot="originNo">
                <span class="is-router-link" @click="checkReceiptDetail(row)">{{ row.originNo }}</span>
            </template>
            <template slot-scope="{ row }" slot="postAt">
                <span>{{ row.postAt === 'Invalid date' ? '' : row.postAt }}</span>
            </template>
            <template slot-scope="{ row }" slot="originStatus">
                <span v-if="row.originStatus === 2">已完成</span>
                <span v-else>未完成</span>
            </template>
            <template slot-scope="{ row }" slot="destroyStatus">
                <span v-if="row.destroyStatus === 1">正常</span>
                <span v-else>打回</span>
            </template>
        </Table>

        <!-- 总量 -->
        <div class="total-info">
            <span>物资总量： <b>{{ orderAllCount }}</b></span>
            <span>物资总价： <b>￥{{ orderAllPrice }}元</b></span>
        </div>

        <!-- 分页 -->
        <div class="pages-box">
            <Page
                :current="condis.pageNumber"
                :total="totalList"
                show-sizer
                :page-size="condis.pageSize"
                @on-change="getChangePageNum"
                @on-page-size-change="getChangePageSize"/>
        </div>
        <!--  -->
        <Modal
            class="model-postion-setting"
            v-model="model"
            title="打回">
            <div class="history-order">
                <span>确定要打回订单{{orderId}}吗?</span>
            </div>
            <template slot="footer">
                <span class="his-cancel" @click="model = false">取消</span>
                <span class="his-ok" @click="submit">确定</span>
            </template>
        </Modal>
    </div>
</template>

<script>
import { selectAllOriginalInfo, deleteOriginalInfo, getAllSettleChannel } from '@/graphql/graphql.js';
import { getMonthFirstDay } from '@/utils/date.js';
import Cookies from 'js-cookie';
import factory from '@/assets/js/ybTool.js';
import '@/assets/js/query.min.js';
import '@/assets/js/jszip.min.js';
export default {
    data() {
        const self = this;
        return {
            // 单据列表加载中状态
            loading: false,

            // 查询加载中状态
            checkLoading: false,

            // 导出加载中状态
            exportLoading: false,
            single: true,
            // 部门 && 部门列表
            department: [],
            departmentData: [],
            timeOut: null,

            // 状态查询
            completeIndex: 0,
            completeLsit: [
                {
                    label: '全部',
                    value: 0
                },
                {
                    label: '未完成',
                    value: 1
                },
                {
                    label: '已完成',
                    value: 2
                }
            ],

            // 查询参数
            condis: {
                organNo: '',
                settleChannel: '',
                startTime: getMonthFirstDay(),
                endTime: getMonthFirstDay(new Date().getDate()),
                originNo: '',
                pageNumber: 1,
                pageSize: 20,
                isDraft: true
            },

            // 分页 全数
            totalList: 0,

            // 选择日期
            startDate: getMonthFirstDay(),
            endDate: getMonthFirstDay(new Date().getDate()),
            options1: {
                disabledDate(date) {
                    return date && date.valueOf() > Date.now();
                }
            },
            options2: {
                disabledDate(date) {
                    return date && date.valueOf() < self.getTimeBegin();
                }
            },

            // 搜索
            filterWord: '',

            columns12: [
                {
                    title: '原始单号',
                    key: 'originNo',
                    slot: 'originNo',
                    width: 170
                },
                {
                    title: '结算渠道',
                    key: 'settleChannel',
                    width: 100
                },
                {
                    title: '组织部门',
                    key: 'path',
                    width: 350
                },
                {
                    title: '项目数',
                    key: 'originalItemsCount',
                    width: 100
                },
                {
                    title: '物资数量',
                    key: 'productCount',
                    width: 100
                },
                {
                    title: '金额',
                    key: 'orderAmount',
                    width: 100
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                    width: 150
                },
                {
                    title: '修改时间',
                    key: 'updatedAt',
                    width: 150
                }
            ],

            receiptData: [],
            exportData: [],

            // 物资合计
            orderAllCount: 0,
            orderAllPrice: 0,
            orderId: '',
            model: false,
            settleChannelList: [],
            settleChannel: 'D00'
        };
    },

    watch: {
        filterWord(val) {
            if (val === '') {
                this.condis.originNo = '';
            }
        }
    },

    beforeMount() {
        window.sessionStorage.removeItem('StepFirst');
        window.sessionStorage.removeItem('projectIsModify');
    },

    mounted() {
        const supplierFun = JSON.parse(window.localStorage.getItem('supplierFunction'));
        if (supplierFun.project1 > -1) {
            this.columns12.splice(1, 0, {
                title: '计划单号',
                key: 'projectId',
                minWidth: 180
            });
        }
        this.getChannelList();
        this.getParams();
        this.getAllOrganList();
    },

    methods: {
        // 结算渠道
        getChannelList() {
            this.$apollo.query({
                query: getAllSettleChannel,
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    all: 1
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getAllSettleChannel;
                const arr = [{
                    label: '全部',
                    value: 'D00'
                }];
                result.data.forEach(item => {
                    item.label = item.name;
                    item.value = item.alias;
                });
                this.settleChannelList = arr.concat(result.data);
            });
        },
        // 获取查询参数
        getParams() {
            const receiptVars = JSON.parse(window.sessionStorage.getItem('receiptList'));
            if (receiptVars) {
                this.condis = receiptVars.condis;
                this.department = receiptVars.receipDepartment;
                this.filterWord = receiptVars.condis.originNo;
                this.settleChannel = receiptVars.condis.settleChannel;
                if (receiptVars.condis.destroyStatus) {
                    this.single = receiptVars.condis.destroyStatus;
                }
                if (receiptVars.condis.originStatus) {
                    this.completeIndex = receiptVars.condis.originStatus;
                }
                this.getReceiptsList();
                window.sessionStorage.removeItem('receiptList');
            } else {
                this.getReceiptsList();
            }
        },

        // 获取单据列表
        getReceiptsList() {
            this.$apollo.query({
                query: selectAllOriginalInfo,
                variables: {
                    condi: this.condis,
                    cliqueNo: Cookies.getJSON('cliqueNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.selectAllOriginalInfo;
                if (data && data.code === 200) {
                    this.totalList = data.total;
                    this.receiptData = data.data;
                    // // 总量 && 总价赋值 默认为0
                    this.orderAllCount = data.totalCount || 0;
                    this.orderAllPrice = data.totalPrince || 0;
                    this.$setNotice('列表查询成功');
                    this.checkLoading = false;
                } else {
                    this.$setNotice(data.message);
                }
            });
        },

        // 获取部门列表
        async getAllOrganList() {
            if (this.$store.state.organs.length) {
                this.departmentData = this.$store.state.organs;
                clearTimeout(this.timeOut);
            } else {
                clearTimeout(this.timeOut);
                this.timeOut = setTimeout(() => {
                    this.getAllOrganList();
                }, 3000);
            }
        },

        // 选中部门
        getCascader(val) {
            this.condis.organNo = val[val.length - 1] || '';
        },

        // 获取格式化日期 && 开始日期
        getFormatStartDate(date) {
            this.condis.startTime = date;
        },

        // 结束日期
        getFormatEndDate(date) {
            this.condis.endTime = date;
        },

        // 单号查询
        search() {
            if (this.filterWord) {
                this.condis.originNo = this.filterWord;
                delete this.condis.startTime;
                delete this.condis.endTime;
                delete this.condis.organNo;
                this.getReceiptsList();
            } else {
                this.$setNotice('搜索内容不能为空');
            }
        },

        // data 中 option2 调用
        getTimeBegin() {
            return Date.parse(this.startDate);
        },

        // 页码变化时回调
        getChangePageNum(val) {
            this.condis.pageNumber = val;
            this.getReceiptsList();
        },

        // 分页显示条数改变
        getChangePageSize(val) {
            this.condis.pageSize = val;
            this.getReceiptsList();
        },

        // 查看详情， 参数传原始单号
        checkReceiptDetail(row) {
            const obj = {
                condis: this.condis,
                receipDepartment: this.department
            };
            window.sessionStorage.setItem('receiptList', JSON.stringify(obj));
            this.$router.push({
                path: '/index/manualBuild',
                query: {
                    originNo: row.originNo,
                    projectId: row.projectId,
                    draft: 1,
                    isLocked: row.isLocked ? '1' : '2'
                }
            });
        },

        // 查询状态
        getCompleteState(val) {
            if (val !== 0) {
                this.condis.originStatus = val;
            } else {
                delete this.condis.originStatus;
            }
        },
        getSettleChannel(val) {
            if (val === 'D00') {
                delete this.condis.settleChannel;
            } else {
                this.condis.settleChannel = val;
            }
        },
        // 包含作废
        singleChange(val) {
            if (val) {
                delete this.condis.destroyStatus;
            } else {
                this.condis.destroyStatus = 1;
            }
        },

        // 查询列表
        checkList() {
            this.checkLoading = true;
            this.condis.pageNumber = 1;
            this.getReceiptsList();
        },

        // 打回订单删除
        removeNo(id) {
            this.orderId = id;
            this.model = true;
        },
        submit() {
            this.$apollo.mutate({
                mutation: deleteOriginalInfo,
                variables: {
                    originNo: this.orderId
                }
            }).then(res => {
                const data = res.data.deleteOriginalInfo;
                if (data && data.code === 200) {
                    this.model = false;
                    this.$setNotice('单据打回成功');
                    this.getReceiptsList();
                }
            });
        }
    }
};
</script>

<style scoped lang="stylus">

@import '../assets/stylus/views/receipt-list.styl'

</style>



// WEBPACK FOOTER //
// src/views/draftList.vue